import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getRecipes, resetField } from "../../../../store/actions";
import RecipesHeader from "./recipesHeader";
import RecipesCard from "./recipesCard";
import Loader from "../../../../sharedComponents/preloader";
import FilterPanel from "../../../../sharedComponents/filterPanel";
import AdvancedFilterPanel from "./advancedFilterPanel";
import DeclineRecipePanel from "./declineRecipePanel";
import NoRecipeImage from "../../../../assets/images/no-recipes-found.png";
import { objToQueryString, queryStringToJSON } from "../../../../utils/common";

import "./RecipesListing.scss";

const Recipes = ({ resetField, recipeList, getRecipes, next, atBottom, history, recipesSearchKeyword, isAdmin, match }) => {
	const matching = match.path === "/nutrition/recipes/approval";
	const approveFilters = matching ? { is_submitted: "True", active: "False" } : {};

	const [recipes, setRecipes] = useState([]);
	const [loading, setLoading] = useState(true);
	const [showLoader, setShowLoader] = useState(true);
	const [fetching, setFetching] = useState(false);

	const [showAdvancedFilterPanel, setShowAdvancedFilterPanel] = useState(false);

	const activeFlag = !isAdmin ? { active: "True" } : {};

	const [filters, setFilters] = useState({
		ordering: "id",
		limit: 30,
		search: "",
		declined: "True",
		...activeFlag
	});
	const [query, setQuery] = useState();

	useEffect(() => {
		const newFilters = { ...filters, ...approveFilters };
		setQuery(objToQueryString(newFilters));
	}, [filters, approveFilters]);

	useEffect(() => {
		if (query) {
			setRecipes([]);
			setLoading(true);
			setShowLoader(true);
			getRecipes(query);
		}
	}, [query, getRecipes]);

	useEffect(() => {
		setLoading(true);
		recipesSearchKeyword && setFilters((prevState) => ({ ...prevState, ...queryStringToJSON(`?${recipesSearchKeyword}`) }));
	}, [recipesSearchKeyword]);

	useEffect(() => {
		setRecipes((prevState) => {
			setShowLoader(false);
			if (recipeList !== null && recipeList.length === 0) {
				setLoading(false);
			}
			return [...prevState, ...(recipeList !== null ? recipeList : [])];
		});
	}, [recipeList]);

	useEffect(() => {
		if (atBottom) {
			setFetching(next ? true : false);
			setLoading(next ? true : false);
		}
	}, [atBottom, next]);

	useEffect(() => {
		fetching && getRecipes(next.split("?")[1]);
		fetching && setShowLoader(true);
		setFetching(false);
	}, [fetching, getRecipes, next]);

	useEffect(() => {
		return () => {
			resetField("Recipes.recipesResult", {});
		};
	}, [resetField]);

	const sortBy = (sort) => {
		setFilters({ ...filters, ordering: sort, declined: "True", ...activeFlag });
	};

	const submitFilter = (values) => {
		setShowAdvancedFilterPanel(false);
		setFilters({
			...values,
			ordering: filters.ordering,
			limit: filters.limit,
			search: filters.search ? filters.search : "",
			declined: "True",
			...activeFlag
		});
	};

	const resetFilter = () => {
		setShowAdvancedFilterPanel(false);
		setFilters({ ordering: filters.ordering, limit: filters.limit, declined: "True", ...activeFlag });
	};

	const renderAdvancedFilterPanel = () => {
		return (
			<FilterPanel
				show={showAdvancedFilterPanel}
				toggle={() => setShowAdvancedFilterPanel(!showAdvancedFilterPanel)}
				title="Filter"
				closeBtn>
				<AdvancedFilterPanel
					toggle={() => setShowAdvancedFilterPanel(!showAdvancedFilterPanel)}
					onSubmit={(values) => submitFilter(values)}
					onReset={resetFilter}
				/>
			</FilterPanel>
		);
	};

	const [showDeclineRecipePanel, setShowDeclineRecipePanel] = useState(false);
	const [recipeToDecline, setRecipeToDecline] = useState(null);

	const declineRecipe = (cardInfo) => {
		setShowDeclineRecipePanel(true);
		setRecipeToDecline(cardInfo);
	};
	const onDeclineSuccess = () => {
		setShowDeclineRecipePanel(false);
		setRecipes(recipes.filter((item) => item.id !== recipeToDecline.id));
	};
	const onDeclineError = () => {
		setShowDeclineRecipePanel(false);
	};

	const renderDeclineRecipePanel = () => {
		return (
			<FilterPanel
				show={showDeclineRecipePanel}
				toggle={() => setShowDeclineRecipePanel(!showDeclineRecipePanel)}
				title="Decline Recipe"
				closeBtn>
				{recipeToDecline && (
					<DeclineRecipePanel onUpdate={onDeclineSuccess} onError={onDeclineError} data={recipeToDecline} />
				)}
			</FilterPanel>
		);
	};

	return (
		<section className="page page-nutritional-list">
			<div className="container">
				<div className="table-container">
					<RecipesHeader
						recipes={recipes}
						sortBy={sortBy}
						toggleAdvancedFilterPanel={() => setShowAdvancedFilterPanel(!showAdvancedFilterPanel)}
						approveBtn={{ show: isAdmin, toggle: approveFilters.is_submitted }}
						history={history}
						isApprovalListing={matching}
						onDropdownSelect={() => setFilters({ ...filters, search: "" })}
					/>
					<div className="card-wrap">
						{recipes && recipes.length
							? recipes.map((card, i) => (
									<RecipesCard
										key={i}
										history={history}
										cardInfo={card}
										edit={{ allow: isAdmin, navs: approveFilters.is_submitted }}
										declineRecipe={declineRecipe}
									/>
							  ))
							: null}

						{loading ? (
							<Loader show={showLoader} />
						) : (
							recipes.length === 0 && (
								<div className="alert alert-info text-center w-100 m-3 no-recipes-found">
									<img src={NoRecipeImage} alt="No recipes found" />
									<div>No recipes found!</div>
								</div>
							)
						)}
					</div>
				</div>
			</div>
			{renderAdvancedFilterPanel()}
			{renderDeclineRecipePanel()}
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Recipes, UI, Auth } = state;
	return {
		recipeList: get(Recipes, "recipesResult.results", null),
		next: get(Recipes, "recipesResult.next"),
		recipesSearchKeyword: get(Recipes, "recipesSearchKeyword", null),
		atBottom: UI.atBottom,
		isAdmin: get(Auth, "isAdmin", "P")
	};
};

const mapDispatchToProps = {
	getRecipes,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Recipes);
